export default __webpack_public_path__ + "static/media/configr_negativo.d03ad4fa.svg";